import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentService } from '../../services/api/paymentService';

export function usePaymentQuery(applicationId) {
  return useQuery({
    queryKey: ['payment', applicationId],
    queryFn: () => paymentService.getApplicationPayment(applicationId),
    enabled: !!applicationId,
    // Retry on 401 since Clerk token might not be ready on first attempt
    retry: (failureCount, error) => {
      if (error?.response?.status === 401 && failureCount < 3) {
        return true;
      }
      return false;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * (attemptIndex + 1), 3000),
  });
}

export function usePaymentHistoryQuery(userId) {
  return useQuery({
    queryKey: ['paymentHistory', userId],
    queryFn: () => paymentService.getPaymentHistory(userId),
    enabled: !!userId,
    // Retry on 401 since Clerk token might not be ready on first attempt
    retry: (failureCount, error) => {
      if (error?.response?.status === 401 && failureCount < 3) {
        return true;
      }
      return false;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * (attemptIndex + 1), 3000),
  });
}

export function useCreateCheckoutSessionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => paymentService.createCheckoutSession(payload),
    onSuccess: (data, variables) => {
      if (variables?.applicationId) {
        queryClient.invalidateQueries({
          queryKey: ['payment', variables.applicationId],
        });
      }
      if (variables?.userId) {
        queryClient.invalidateQueries({
          queryKey: ['applications', variables.userId],
        });
      }
    },
  });
}

export function useVerifyPaymentSessionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sessionId }) => paymentService.verifySession(sessionId),
    onSuccess: (data, variables) => {
      if (variables?.applicationId) {
        queryClient.invalidateQueries({
          queryKey: ['payment', variables.applicationId],
        });
      }
      if (variables?.userId) {
        queryClient.invalidateQueries({
          queryKey: ['applications', variables.userId],
        });
      }
    },
  });
}
